var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#303c42;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Delivery_Truck","data-name":"Delivery Truck"},React.createElement("g",{"id":"_Group_","data-name":"<Group>"},[React.createElement("path",{"id":"_Path_","data-name":"<Path>","className":"cls-1","d":"M20.5 5.5v5h6","key":0}),React.createElement("path",{"className":"cls-1","d":"M16.5 3.5v16m-7.18 0h11.36m5.64 0H28a1.5 1.5 0 0 0 1.5-1.5V9.5l-6-6h-7v-3H2A1.5 1.5 0 0 0 .5 2v16A1.5 1.5 0 0 0 2 19.5h1.68","key":1}),React.createElement("circle",{"id":"_Path_2","data-name":"<Path>","className":"cls-1","cx":"6.5","cy":"18.5","r":"3","key":2}),React.createElement("circle",{"id":"_Path_3","data-name":"<Path>","className":"cls-1","cx":"23.5","cy":"18.5","r":"3","key":3})])))]);
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 30 22"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
